/*
 * コンタクトフォームの本文を、商品ページからのクエリ（kf_title / kf_sku / kf_url）で自動入力する（Issue #275）。
 * - 本文欄（#ContactForm-body）が空のときだけ入れる（エラー再送・入力済みを上書きしない）。
 * - Dawn の contact-form.liquid は編集せず、このスクリプトだけで完結させる。
 * - クエリは URLSearchParams で読む（url_encode の + は空白として解かれる）。
 */
(function () {
  function prefill(doc, search) {
    var params = new URLSearchParams(search || '');
    var title = params.get('kf_title');
    var sku = params.get('kf_sku');
    var url = params.get('kf_url');
    if (!title && !sku && !url) return false;

    var body = doc.getElementById('ContactForm-body');
    if (!body) return false;
    if (body.value.trim() !== '') return false; // 既入力・エラー再送は触らない

    var lines = [];
    if (title) lines.push('【商品お問い合わせ】' + title);
    if (sku) lines.push('SKU: ' + sku);
    if (url) lines.push('商品URL: ' + url);
    lines.push('', ''); // お客様が本文を書くための空行
    body.value = lines.join('\n');
    return true;
  }

  if (typeof window !== 'undefined' && typeof document !== 'undefined') {
    prefill(document, window.location.search);
  }
})();
